const de = {
  // Header
  nav_home: 'Startseite',
  nav_booking: 'Buchen',
  nav_therapists: 'Therapeuten',
  menu_label: 'Menü',

  // Hero
  hero_badge: 'Premium Thai Massage',
  hero_title: 'Erleben Sie die beste\nThai-Massage',
  hero_subtitle: 'Buchen Sie eine Premium-Massage bei professionellen Therapeuten in Pattaya, Phuket, Bangkok und Korat',
  hero_book_now: 'Jetzt buchen',
  hero_view_therapists: 'Therapeuten ansehen',
  stat_therapists: 'Experten-Therapeuten',
  stat_locations: 'Standorte',
  stat_rating: 'Ø Bewertung',

  // Features
  feature_gps_title: 'GPS-Autoerkennung',
  feature_gps_desc: 'Findet automatisch den nächstgelegenen Standort von Ihrer Position',
  feature_booking_title: 'Einfache Buchung',
  feature_booking_desc: 'Buchen Sie eine Massage einfach in nur 5 Schritten',
  feature_verified_title: 'Verifizierte Therapeuten',
  feature_verified_desc: 'Professionell verifizierte Therapeuten mit nachgewiesener Erfahrung',

  // Nearby therapists section
  nearby_title: 'Therapeuten in Ihrer Nähe',
  nearby_subtitle: 'Empfohlene Therapeuten basierend auf Ihrem GPS-Standort',
  nearby_loading: 'Standort wird ermittelt...',
  nearby_error: 'Standort konnte nicht ermittelt werden',
  nearby_retry: 'Erneut versuchen',
  nearby_distance: '{distance} km entfernt',
  nearby_book: 'Jetzt buchen',

  // Locations section
  section_locations_title: 'Verfügbare Standorte',
  section_locations_subtitle: 'Wir bieten Service in 5 Großstädten Thailands',
  loc_book: 'Buchen',

  // Courses section
  section_courses_title: 'Massage-Kurse',
  section_courses_subtitle: 'Entdecken Sie unsere verschiedenen Massage-Programme',

  // Therapists section
  section_therapists_title: 'Beliebte Therapeuten',
  section_therapists_subtitle: 'Lernen Sie unsere bestbewerteten Therapeuten kennen',
  view_all_therapists: 'Alle Therapeuten ansehen',

  // CTA
  cta_title: 'Jetzt buchen',
  cta_subtitle: 'Das beste Thai-Massage-Erlebnis wartet auf Sie',
  cta_book: 'Buchen',

  // Footer
  footer_copyright: '© 2026 Thai Massage Booking. Alle Rechte vorbehalten.',

  // Booking Steps
  step_location: 'Standort',
  step_course: 'Kurs',
  step_therapist: 'Therapeut',
  step_datetime: 'Datum/Zeit',
  step_confirm: 'Bestätigung',

  // Booking - Step 1
  booking_location_title: 'Wählen Sie einen Standort',
  booking_location_desc: 'Wählen Sie den Bereich für Ihre Massage',
  gps_detect: 'Meinen Standort erkennen',
  gps_loading: 'Standort wird erkannt...',

  // Booking - Step 2
  booking_course_title: 'Wählen Sie einen Massage-Kurs',
  booking_course_desc: 'Wählen Sie Ihren bevorzugten Massagetyp und Dauer',
  duration_min: '{min} Min.',

  // Booking - Step 3
  booking_therapist_title: 'Wählen Sie einen Therapeuten',
  booking_therapist_desc: 'Verfügbare Therapeuten in {location}',
  no_therapist: 'Keine Therapeuten für den gewählten Standort und Kurs verfügbar.',
  no_therapist_suggest: 'Bitte wählen Sie einen anderen Kurs.',

  // Booking - Step 4
  booking_datetime_title: 'Wählen Sie Datum und Uhrzeit',
  booking_datetime_desc: 'Wählen Sie Ihr bevorzugtes Datum und Uhrzeit',
  date_select: 'Datum wählen',
  time_select: 'Uhrzeit wählen',
  time_placeholder: 'Bitte wählen Sie zuerst ein Datum',
  time_notice: 'Die Anreise des Therapeuten kann je nach Entfernung bis zu 2 Stunden dauern. Bitte wählen Sie eine Zeit mit ausreichend Puffer.',

  // Booking - Step 5
  booking_confirm_title: 'Bestätigen Sie Ihre Buchung',
  booking_confirm_desc: 'Überprüfen Sie alle Informationen und geben Sie Ihre Kontaktdaten ein',
  summary_location: 'Standort',
  summary_course: 'Kurs',
  summary_price: 'Preis',
  summary_therapist: 'Therapeut',
  summary_date: 'Datum',
  summary_time: 'Uhrzeit',
  health_check_title: 'Gesundheitszustand',
  health_check_desc: 'Bitte teilen Sie uns mit, ob Sie gesundheitliche Probleme, Schmerzen oder Bereiche haben, die bei der Massage ausgelassen werden sollen.',
  health_check_placeholder: 'z.B. Ich habe Bluthochdruck / Meine rechte Schulter ist verletzt, bitte den Oberkörper sanft behandeln / Bitte den unteren Rücken wegen Bandscheibenvorfall auslassen',
  health_check_examples: 'z.B. Ich habe Bluthochdruck / Meine rechte Schulter ist verletzt, bitte den Oberkörper sanft behandeln / Bitte den unteren Rücken wegen Bandscheibenvorfall auslassen',
  contact_title: 'Kontaktdaten',
  contact_name: 'Name',
  contact_name_placeholder: 'Geben Sie Ihren Namen ein',
  contact_phone: 'Telefonnummer',
  contact_phone_placeholder: 'Geben Sie Ihre Telefonnummer ein',
  contact_email: 'E-Mail',
  contact_email_placeholder: 'Geben Sie Ihre E-Mail-Adresse ein',
  contact_note: 'Besondere Wünsche',
  contact_note_placeholder: 'Geben Sie besondere Wünsche ein',
  required_mark: '*',

  // Navigation buttons
  btn_prev: 'Zurück',
  btn_next: 'Weiter',
  btn_complete: 'Buchung bestätigen',

  // Therapist card
  age_suffix: ' J.',
  experience_years: '{years} J. Erfahrung',

  // Therapist list page
  tl_title: 'Therapeuten',
  tl_subtitle: 'Lernen Sie unsere Top-Therapeuten kennen, verifiziert durch Erfahrung und Expertise',
  tab_all: 'Alle',

  // Confirmation page
  conf_empty_title: 'Keine Buchungsinformationen',
  conf_empty_desc: 'Bitte buchen Sie auf der Buchungsseite.',
  conf_empty_btn: 'Buchen',
  conf_success_title: 'Buchung bestätigt!',
  conf_success_subtitle: 'Ihre Buchung wurde bestätigt. Vielen Dank.',
  conf_preparation_title: 'Buchung nicht eingegangen',
  conf_preparation_subtitle: 'Unser Service befindet sich in der Vorbereitung, daher ist Ihre Buchung noch nicht bestätigt. Wir melden uns nach dem offiziellen Start.',
  conf_preparation_notice: 'Der Service wird vorbereitet — diese Buchung ist keine bestätigte Reservierung.',
  conf_booking_id: 'Buchungsnr.',
  conf_detail_title: 'Buchungsdetails',
  conf_label_location: 'Standort',
  conf_label_course: 'Massage-Kurs',
  conf_label_price: 'Preis',
  conf_label_therapist: 'Therapeut',
  conf_label_date: 'Datum',
  conf_label_time: 'Uhrzeit',
  conf_label_email: 'E-Mail',
  conf_label_contact: 'Kontakt',
  conf_label_note: 'Besondere Wünsche',
  conf_notice_title: 'Wichtiger Hinweis',
  conf_notice_1: 'Die Anreise des Therapeuten kann je nach Entfernung bis zu 2 Stunden dauern.',
  conf_notice_2: 'Bitte kontaktieren Sie uns telefonisch für Änderungen oder Stornierungen.',
  conf_notice_3: 'Die Zahlung kann vor Ort bar oder per Karte erfolgen.',
  conf_btn_home: 'Startseite',
  conf_btn_new: 'Neue Buchung',

  // Geolocation errors
  GEO_NOT_SUPPORTED: 'Ihr Browser unterstützt kein GPS.',
  GEO_PERMISSION_DENIED: 'Standortzugriff wurde verweigert. Bitte wählen Sie einen Standort manuell.',
  GEO_POSITION_UNAVAILABLE: 'Standortinformationen sind nicht verfügbar.',
  GEO_TIMEOUT: 'Standortanfrage ist abgelaufen.',
  GEO_UNKNOWN: 'Ein unbekannter Fehler ist aufgetreten.',

  // SEO
  seo_home_title: 'Mobile Massage Thailand buchen | Bangkok In Home Massage',
  seo_home_desc: 'Zertifizierte Therapeuten kommen zu Ihrem Hotel in Bangkok, Pattaya, Phuket, Chiang Mai und Korat. Thai-Massage, Aromatherapie und Öl-Massage bequem online buchen.',
  seo_therapists_title: 'Mobile Massage Therapeuten | Bangkok In Home Massage',
  seo_therapists_desc: 'Zertifizierte Therapeuten in Bangkok, Pattaya, Phuket, Chiang Mai und Korat. Profile, Bewertungen und Fachgebiete ansehen und direkt online buchen.',
  seo_booking_title: 'Mobile Massage online buchen | Bangkok In Home Massage',
  seo_booking_desc: 'Standort, Massageart und Therapeut wählen, um eine mobile Massage zu buchen. Unsere Therapeuten kommen zu Ihrem Hotel oder Ihrer Unterkunft.',

  // Body info
  height_label: 'Größe',
  weight_label: 'Gewicht',

  // GPS therapist list
  gps_find_nearby: 'Therapeuten in der Nähe finden',
  gps_nearby_active: 'Nach Entfernung sortiert',

  // Notices
  notice_punctual: 'Der Therapeut kommt zum vereinbarten Datum und Uhrzeit. Bitte seien Sie pünktlich bereit.',
  notice_no_sexual: 'Dies ist ein professioneller Massage-Service. Sexuelle Dienstleistungen sind streng untersagt.',

  // Guide section
  guide_title: 'Service-Leitfaden',
  guide_subtitle: 'Bitte lesen Sie die folgenden Informationen für ein angenehmes Erlebnis',
  guide_before_title: 'Vor der Behandlung',
  guide_before_text: 'Eine leichte Dusche vor der Behandlung wird empfohlen. Bitte vermeiden Sie Termine direkt nach dem Essen. Bei Trunkenheit kann die Behandlung abgelehnt werden. Bei Vorerkrankungen (Bluthochdruck, Herzerkrankungen usw.) oder Schwangerschaft geben Sie dies bitte bei der Buchung unter besondere Wünsche an.',
  guide_booking_title: 'Buchungsinfo',
  guide_booking_text: 'Die Anreise des Therapeuten kann je nach Entfernung bis zu 2 Stunden dauern. Bitte wählen Sie eine Zeit mit ausreichend Puffer. Für Änderungen oder Stornierungen kontaktieren Sie uns bitte telefonisch.',
  guide_session_title: 'Während der Behandlung',
  guide_session_text: 'Der Therapeut kommt zur gebuchten Zeit zu Ihrer Unterkunft. Wenn Sie sich während der Behandlung unwohl fühlen, informieren Sie bitte sofort den Therapeuten. Dies ist ein professioneller Massage-Service. Sexuelle Dienstleistungen sind streng untersagt.',
  guide_after_title: 'Nach der Behandlung',
  guide_after_text: 'Bitte trinken Sie ausreichend Wasser. Vorübergehende Muskelschmerzen oder Müdigkeit sind normal und klingen innerhalb von 2-3 Tagen ab. Bitte vermeiden Sie übermäßigen Alkoholkonsum und intensives Training am Tag der Behandlung.',
  guide_payment_title: 'Zahlung',
  guide_payment_text: 'Die Zahlung kann vor Ort bar oder per Karte erfolgen.',

  // FAQ
  faq_q1: 'Wie funktioniert der mobile Massage-Service?',
  faq_a1: 'Wählen Sie Ihren Standort, den Massagetyp, einen Therapeuten und buchen Sie Datum und Uhrzeit. Der Therapeut kommt zu Ihrem Hotel oder Ihrer Unterkunft.',
  faq_q2: 'In welchen Gebieten bieten Sie Service an?',
  faq_a2: 'Wir bieten professionelle mobile Massage-Services in Bangkok, Pattaya, Phuket, Chiang Mai und Korat an.',
  faq_q3: 'Wie kann ich meine Buchung ändern oder stornieren?',
  faq_a3: 'Bitte kontaktieren Sie uns telefonisch für Änderungen oder Stornierungen. Die Zahlung kann vor Ort bar oder per Karte erfolgen.',

  // 404
  notfound_title: 'Seite nicht gefunden',
  notfound_desc: 'Die angeforderte Seite existiert nicht oder wurde verschoben.',
  notfound_home: 'Zur Startseite',
};

export default de;
